'use client'

// Whether the signed-in student's school has turned the AI tutor off.
//
// The root layout reads it once on the server and provides it here, so every
// Sage surface (the floating button, the chat under a question, the dashboard
// nudge) can disappear instead of offering a feature the API will refuse.
// The API routes enforce the same switch (src/lib/school/student-mode.ts) —
// this only keeps the UI honest.

import { createContext, useContext, type ReactNode } from 'react'

const SchoolAiBlockedContext = createContext(false)

export function SchoolAiAccessProvider({
  blocked,
  children,
}: {
  blocked: boolean
  children: ReactNode
}) {
  return (
    <SchoolAiBlockedContext.Provider value={blocked}>{children}</SchoolAiBlockedContext.Provider>
  )
}

export function useSchoolAiBlocked(): boolean {
  return useContext(SchoolAiBlockedContext)
}

/** Renders its children only when the school allows the AI tutor. */
export function SchoolAiGate({ children }: { children: ReactNode }) {
  return useSchoolAiBlocked() ? null : <>{children}</>
}
